import * as ActionTypes from '../constants/link/MyLInkActionTypes'

export const receiveLink = (data) => ({
	type: ActionTypes.RECEIVE_MY_LINK,
	data
})

export const deleteLink = (linkId) => ({
	type: ActionTypes.DELETE_LINK,
	linkId
})

export const updateLink = (link) => ({
	type: ActionTypes.UPDATE_LINK,
	link
})

export const addLink = (link) => ({
	type: ActionTypes.ADD_LINK,
	link
})

export const moveLink = (dragIndex, hoverIndex, isTemporary) => ({
	type: ActionTypes.MOVE_LINK,
	dragIndex, hoverIndex, isTemporary
})

export const dropLink = (dragIndex) => ({
	type: ActionTypes.DROP_LINK,
	dragIndex
})

export const changeSaveStatus = (saving) => ({
	type: ActionTypes.CHANGE_SAVE_STATUS,
	saving
})

export const afterSave = () => ({
	type: ActionTypes.AFTER_SAVE
})
